import { Link } from "react-router-dom";
import Modal from "./components/Modal";
import useModal from "./components/Modal/useModal";
import song from "./assets/song.mp3";
import PlayMusic from "./components/PlayMusic";

function Home() {
  const { isShowing, toggle } = useModal();

  return (
    <div>
      <div>
        <button
          className="button-default relative text-red-600 mt-[40px] ml-[40px] bg-[#d5ffc8] px-3 py-3 border-2 rounded-xl text-2xl font-bold"
          onClick={toggle}
        >
          Thông báo (1)
        </button>

        <PlayMusic url={song} />
      </div>
      <div className="flex items-center justify-center h-screen">
        <Modal isShowing={isShowing} hide={toggle} />

        <Link to="/letplay">
          <div
            className="w-[120px] h-[120px] p-[10px] text-center rounded-lg text-[#262e51] text-3xl font-bold cursor-pointer bg-[#f8c1bd]"
            style={{
              boxShadow:
                "inset 5px 5px 15px #ebd6ad,inset -5px -5px 15px #ef5057",
            }}
          >
            BẮT ĐẦU
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Home;
